'use strict';

export function init() {
  const sections = document.querySelectorAll('.orchestra-roster__featured-section, .orchestra-roster__group');
  const navList = document.querySelector('.meet-sticky-bar__list');
  const navLinks = document.querySelectorAll('.meet-sticky-bar__link');
  const links = [];
  let lastActiveLink = null;

  if (navList) {
    navLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          links.push(link);
        }
      }
    });

    const observerOptions = {
      root: null,
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    };

    const observerCallback = entries => {
      entries.forEach(entry => {
        const sectionId = entry.target.id;
        const navLink = document.querySelector(`.meet-sticky-bar__link[href="#${sectionId}"]`);

        if (entry.isIntersecting) {
          if (navLink) {
            links.forEach(link => link.classList.remove('active'));
            navLink.classList.add('active');
            lastActiveLink = navLink;
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    sections.forEach(section => observer.observe(section));

    // Handle click navigation
    if (navList) {
      navList.addEventListener('click', function(e) {
        const meetStickyBar = document.querySelector('.meet-sticky-bar');
        const orchestraNavigation = document.querySelector('.orchestra-roster__navigation--inner');
        const stickyBarHeight = meetStickyBar ? meetStickyBar.offsetHeight : 0;
        const navigationHeight = orchestraNavigation ? orchestraNavigation.offsetHeight : 0;

        if (e.target && e.target.tagName === 'A') {
          e.preventDefault();
          const targetSection = document.querySelector(e.target.getAttribute('href'));
          const scrollOffset = targetSection.offsetTop - stickyBarHeight - navigationHeight;

          window.scrollTo({
            top: scrollOffset,
            behavior: 'smooth'
          });
        }
      });
    }

    window.addEventListener('scroll', () => {
      if (!document.querySelector('.meet-sticky-bar__link.active') && lastActiveLink) {
        lastActiveLink.classList.add('active');
      }
    });
  }
}
